import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    // Assistant transcript's text region — see
    // apps/hub/src/modules/core/assistant/Screens/DefaultScreen/styles.ts.
    text: {
      maxHeight: 108,
      overflowY: 'auto',
      lineHeight: 1.6,
      fontSize: 17,
      color: colors.white,

      '&::-webkit-scrollbar': {
        width: 4,
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(255,255,255,0.25)',
        borderRadius: 4,
      },
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(255,255,255,0.25) transparent',
    },
  };
};
